import { Relation, RideDetails } from '../api-interfaces';

interface RelationFilterCriteria {
    segmentId?: string;
    relationId?: string;
}

/**
 *
 * @param filterBy Identifier of the segment or relation as given by url-param. {from_stop_uuid}_{to_stop_uuid} or undefined
 * @param rideData Pass data to be filtered on
 * @returns Relevant relations that is:
 *      - All relations if no filter criteria is given
 *      - Only relations crossing the given segment
 *      - Only one relation, based on the relationId
 */
export function filterRelations(filterBy: RelationFilterCriteria, rideData: RideDetails): Array<Relation> {
    let consideredRelations = rideData.relations;
    if (filterBy.segmentId) {
        const [fromStopUuid, toStopUuid] = filterBy.segmentId.split('_');
        // Map stop uuids to the order in which the stop is traveled to
        const stopSequence: { [stopUuid: string]: number } = {};
        rideData.segments.forEach((segment, index) => {
            stopSequence[segment.from_uuid] = index;
            if (index === rideData.segments.length - 1) {
                stopSequence[segment.to_uuid] = index + 1;
            }
        });
        const lowerBound = stopSequence[fromStopUuid];
        const upperBound = stopSequence[toStopUuid];
        const crossingRelations = rideData.relations.filter((relation) => {
            return stopSequence[relation.from_uuid] <= lowerBound && stopSequence[relation.to_uuid] >= upperBound;
        });
        consideredRelations = crossingRelations;
    } else if (filterBy.relationId) {
        const [fromStopUuid, toStopUuid] = filterBy.relationId.split('_');
        consideredRelations = rideData?.relations.filter(
            (r) => r.from_uuid === fromStopUuid && r.to_uuid === toStopUuid
        );
    }
    return consideredRelations;
}
